<template lang="pug">
.mt-4
  FlowEditor(
    v-if="flows && flows.length > 0",
    :expert="true",
    :flowAliases="aliases",
    :flows="flows"
  )
  v-card.mt-4
    v-card-title Do you approve Case Profile?
    v-card-text 
      v-chip(
        v-if="decision.Valid",
        :color="decision.Bool ? 'green' : 'red'",
        text-color="white"
      ) {{ decision.Bool ? 'Approved' : 'Rejected' }}
      .d-flex.justify-space-around.pa-4(v-else)
        v-btn(color="warning", @click="reject", :loading="isRejectLoading") reject
        v-btn(color="success", @click="approve", :loading="isApproveLoading") approve
</template>

<script>
import FlowEditor from "@/components/FlowEditor";
import { expertAPI } from "@/utils/apiUrls.js";

export default {
  name: "expert-case-profile",

  components: {
    FlowEditor,
  },

  data: () => ({
    aliases: [
      "case_free",
      "case_paid",
      "case_paid_key",
      "case_paid_officer",
      "case_paid_cos",
      "case_paid_lvl1",
    ],
    isRejectLoading: false,
    isApproveLoading: false,
  }),

  methods: {
    approve() {
      this.isApproveLoading = true;
      this.axios
        .get(
          expertAPI.usercase.sponsorship.decision.ApproveCaseProfileURL(
            this.usercase.ID
          )
        )
        .then(() => this.$store.dispatch("expert/usercase/refreshUsercase"))
        .finally(() => (this.isApproveLoading = false));
    },

    reject() {
      this.axios
        .get(
          expertAPI.usercase.sponsorship.decision.RejectCaseProfileURL(
            this.usercase.ID
          )
        )
        .then(() => this.$store.dispatch("expert/usercase/refreshUsercase"))
        .finally(() => (this.isApproveLoading = false));
    },
  },

  computed: {
    flows() {
      return this.$store.state.expert.usercase.userflows;
    },

    usercase() {
      return this.$store.state.expert.usercase.usercase;
    },

    decision() {
      return this.usercase.case_profile_review;
    },

    caseID() {
      return this.usercase.ID;
    },
  },
};
</script>